export default "__VITE_ASSET__BagppTyD__"